import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}restdesigner/dynamicPublisher`

export default {
  getIsInProgress() {
    return ApiService.get(`${resourceUrl}/isInProgress`)
  },
}
